// tslint:disable:max-line-length

import React from 'react';

export const EditorTextColor = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="12" width="16" height="4" />
      <path d="M4.1,9l3.2-9h1.5l3.2,9h-1.6L9.6,6.9H6.2L5.5,9H4.1z M6.7,5.5h2.5L8,1.9h0L6.7,5.5z" />
    </svg>
  );
};
